import React from 'react';

import classNames from 'classnames';

import { Card, CardProps } from '@ast/magma/components/card';

import styles from './FullscreenCard.pcss';

/**
 * Card used for content of full screen layout
 */
export const FullScreenCard = (props:CardProps & React.HTMLAttributes<HTMLDivElement>) => {
  const { className, children, ...otherProps } = props;
  return (
    <Card
      className={classNames(className, styles.card)}
      {...otherProps}
    >
      {children}
    </Card>
  );
};
